// Mock data for PriceCapture-UNO

export const FUEL_TYPES = [
  { id: 'vpower', name: 'V-Power', color: '#7c1d2e' },
  { id: 'super', name: 'Súper', color: '#b91c1c' },
  { id: 'regular', name: 'Regular', color: '#15803d' },
  { id: 'diesel', name: 'Diesel', color: '#374151' },
  { id: 'ulsd', name: 'ULSD', color: '#1e40af' },
];

export const OWN_BRANDS = ['Shell', 'UNO'];

export const SERVICE_TYPES = [
  { id: 'self', name: 'Autoservicio' },
  { id: 'full', name: 'Servicio Completo' },
];

export const BRANDS = ['UNO', 'Puma', 'Texaco', 'Shell', 'Total', 'Esso', 'Petromaya'];

export const STATIONS = [
  { id: 's1', name: 'UNO Roosevelt', brand: 'UNO', address: 'Calzada Roosevelt 12-23, Zona 7', lat: 14.6235, lng: -90.5469, region: 'Ciudad de Guatemala' },
  { id: 's2', name: 'Puma Vista Hermosa', brand: 'Puma', address: 'Bulevar Vista Hermosa 23-50, Zona 15', lat: 14.6112, lng: -90.4923, region: 'Ciudad de Guatemala' },
  { id: 's3', name: 'Texaco Reforma', brand: 'Texaco', address: 'Avenida Reforma 9-55, Zona 9', lat: 14.6094, lng: -90.5132, region: 'Ciudad de Guatemala' },
  { id: 's4', name: 'Shell Aguilar Batres', brand: 'Shell', address: 'Calzada Aguilar Batres 35-12, Zona 12', lat: 14.5723, lng: -90.5476, region: 'Ciudad de Guatemala' },
  { id: 's5', name: 'UNO Mateo Flores', brand: 'UNO', address: 'Calzada Mateo Flores 11-45, Zona 5', lat: 14.6498, lng: -90.5021, region: 'Ciudad de Guatemala' },
  { id: 's6', name: 'Total Las Américas', brand: 'Total', address: 'Av. Las Américas 6-11, Zona 14', lat: 14.5876, lng: -90.5113, region: 'Ciudad de Guatemala' },
  { id: 's7', name: 'Puma Atanasio Tzul', brand: 'Puma', address: 'Calzada Atanasio Tzul 18-23, Zona 12', lat: 14.5612, lng: -90.5398, region: 'Ciudad de Guatemala' },
  { id: 's8', name: 'Esso San Cristóbal', brand: 'Esso', address: 'Calzada San Juan, San Cristóbal', lat: 14.6098, lng: -90.6234, region: 'Mixco' },
  { id: 's9', name: 'UNO Mixco', brand: 'UNO', address: 'Calzada Roosevelt 38-12, Mixco', lat: 14.6312, lng: -90.6087, region: 'Mixco' },
  { id: 's10', name: 'Texaco Carretera Salvador', brand: 'Texaco', address: 'Carretera a El Salvador Km 14.5', lat: 14.5934, lng: -90.4287, region: 'Santa Catarina Pinula' },
  { id: 's11', name: 'Shell Antigua', brand: 'Shell', address: '6a Calle Poniente, Antigua Guatemala', lat: 14.5586, lng: -90.7295, region: 'Antigua' },
  { id: 's12', name: 'Puma Quetzaltenango', brand: 'Puma', address: 'Calzada Independencia, Zona 3', lat: 14.8451, lng: -91.5181, region: 'Quetzaltenango' },
  { id: 's13', name: 'UNO Petapa', brand: 'UNO', address: 'Calzada Petapa 42-15, Zona 12', lat: 14.5567, lng: -90.5589, region: 'Ciudad de Guatemala' },
  { id: 's14', name: 'Total Naranjo', brand: 'Total', address: 'Calzada San Juan, Zona 7', lat: 14.6356, lng: -90.5523, region: 'Ciudad de Guatemala' },
  { id: 's15', name: 'Texaco Villa Nueva', brand: 'Texaco', address: 'Calzada Aguilar Batres, Villa Nueva', lat: 14.5267, lng: -90.5876, region: 'Villa Nueva' },
];

export const PRICE_ENTRIES = [
  {
    id: 'p1', stationId: 's1', stationName: 'UNO Roosevelt', brand: 'UNO',
    capturedBy: 'Carlos Méndez', capturedAt: '2025-07-22T08:30:00Z',
    serviceType: 'self', status: 'approved',
    prices: { vpower: 38.45, super: 36.20, regular: 34.10, diesel: 32.85 },
    photo: null, lat: 14.6235, lng: -90.5469, notes: ''
  },
  {
    id: 'p2', stationId: 's2', stationName: 'Puma Vista Hermosa', brand: 'Puma',
    capturedBy: 'Ana López', capturedAt: '2025-07-22T09:15:00Z',
    serviceType: 'full', status: 'pending',
    prices: { vpower: 38.65, super: 36.40, regular: 34.30, diesel: 33.05 },
    photo: null, lat: 14.6112, lng: -90.4923, notes: 'Precio competitivo'
  },
  {
    id: 'p3', stationId: 's3', stationName: 'Texaco Reforma', brand: 'Texaco',
    capturedBy: 'Carlos Méndez', capturedAt: '2025-07-22T10:00:00Z',
    serviceType: 'self', status: 'approved',
    prices: { vpower: null, super: 36.15, regular: 34.05, diesel: 32.80 },
    photo: null, lat: 14.6094, lng: -90.5132, notes: ''
  },
  {
    id: 'p4', stationId: 's4', stationName: 'Shell Aguilar Batres', brand: 'Shell',
    capturedBy: 'María Pérez', capturedAt: '2025-07-21T14:20:00Z',
    serviceType: 'self', status: 'flagged',
    prices: { vpower: 39.10, super: 37.00, regular: 35.20, diesel: 33.50 },
    photo: null, lat: 14.5723, lng: -90.5476, notes: 'Precio inusualmente alto'
  },
  {
    id: 'p5', stationId: 's5', stationName: 'UNO Mateo Flores', brand: 'UNO',
    capturedBy: 'Ana López', capturedAt: '2025-07-21T16:45:00Z',
    serviceType: 'self', status: 'approved',
    prices: { vpower: 38.40, super: 36.15, regular: 34.05, diesel: 32.80 },
    photo: null, lat: 14.6498, lng: -90.5021, notes: ''
  },
];

export const USERS = [
  { id: 'u1', name: 'Admin Principal', email: 'admin@pricecapture.gt', role: 'admin', region: 'Todas', status: 'active', lastActive: '2025-07-22T11:00:00Z' },
  { id: 'u2', name: 'Carlos Méndez', email: 'carlos@pricecapture.gt', role: 'capturer', region: 'Ciudad de Guatemala', status: 'active', lastActive: '2025-07-22T10:00:00Z' },
  { id: 'u3', name: 'Ana López', email: 'ana@pricecapture.gt', role: 'capturer', region: 'Mixco', status: 'active', lastActive: '2025-07-22T09:15:00Z' },
  { id: 'u4', name: 'María Pérez', email: 'maria@pricecapture.gt', role: 'capturer', region: 'Quetzaltenango', status: 'active', lastActive: '2025-07-21T14:20:00Z' },
  { id: 'u5', name: 'Roberto Castillo', email: 'roberto@pricecapture.gt', role: 'capturer', region: 'Villa Nueva', status: 'inactive', lastActive: '2025-07-15T08:00:00Z' },
];

export const STATS = {
  totalStations: 15,
  totalCaptures: 248,
  pendingApproval: 12,
  activeCapturers: 4,
  weeklyChange: 8.4,
};

export const RECENT_ACTIVITY = [
  { id: 'a1', type: 'capture', user: 'Carlos Méndez', station: 'UNO Roosevelt', time: '10 min' },
  { id: 'a2', type: 'approval', user: 'Admin', station: 'Puma Vista Hermosa', time: '25 min' },
  { id: 'a3', type: 'capture', user: 'Ana López', station: 'UNO Mateo Flores', time: '1 h' },
  { id: 'a4', type: 'flag', user: 'Sistema', station: 'Shell Aguilar Batres', time: '2 h' },
  { id: 'a5', type: 'capture', user: 'María Pérez', station: 'Shell Antigua', time: '5 h' },
];
